import {cloneElement} from 'react'
import utils from '@eitje/utils'
import {Layout} from '../../../layout'

export const SelectFooter = ({footerButtons}) => {
	const buttonArray = utils.alwaysDefinedArray(footerButtons)
	if (!buttonArray.length) return null

	const buttons = buttonArray.map((button, key) => cloneElement(button, {key}))

	return (
		<Layout className="select-footer" direction="vertical" padding="8" width="full" background="light-grey" borderTop>
			{buttons}
		</Layout>
	)
}
